import React, { useState } from 'react';
import { motion, AnimatePresence, LayoutGroup } from 'framer-motion';
import { UserPlusIcon, UserMinusIcon } from 'lucide-react';
import { OnboardingWizard } from './pages/OnboardingWizard';
import { Logo } from './components/Logo';
interface AppProps {
  /** Standalone admin tab, or the slim step embedded in the termination Screen Flow */
  offboardingContext?: 'standalone' | 'flow';
  /** Result of the borrower reassignment step in flow mode */
  flowOutcome?: 'success' | 'followUp';
}
export function App({
  offboardingContext = 'standalone',
  flowOutcome = 'success'
}: AppProps) {
  const [mode, setMode] = useState<'onboarding' | 'offboarding' | null>(null);
  return <LayoutGroup data-id="element-0" data-mp="2wjgqzi86lvgf">
      <AnimatePresence mode="wait" data-id="element-1" data-mp="2wiyy8vkq9zd9">
        {mode === null ? <motion.div key="splash" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0,
        transition: {
          duration: 0.3
        }
      }} className="min-h-screen w-full bg-[#F0F2F5] flex flex-col items-center justify-center p-4 font-sans" data-id="element-2" data-mp="28ufmg62gz4gf">
            <motion.div initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          ease: 'easeOut'
        }} className="text-center mb-12" data-id="element-3" data-mp="3rdarmj8qkein">
              <Logo size="lg" className="mx-auto mb-5" data-id="element-4" data-mp="38l8h7pmotugu" />
              <h1 className="text-xl font-medium text-gray-500 tracking-wide" data-id="element-5" data-mp="38nuqbtp88i16">
                User Management Console
              </h1>
            </motion.div>

            <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2,
          ease: 'easeOut'
        }} className="flex flex-col sm:flex-row items-center gap-4 sm:gap-6" data-id="element-6" data-mp="nuhj4kutefvc">
              <motion.button layoutId="onboarding-toggle" onClick={() => setMode('onboarding')} className="flex items-center justify-center w-full sm:w-56 py-4 px-6 bg-navy-600 text-white rounded-xl shadow-lg hover:bg-navy-700 hover:shadow-xl hover:-translate-y-0.5 transition-[transform,box-shadow,background-color] duration-200 ease-out group" data-id="element-7" data-mp="d2bibguajxvo">
                <UserPlusIcon className="w-5 h-5 mr-3 group-hover:scale-110 transition-transform" data-id="element-8" data-mp="3lkhdnzz333lk" />
                <span className="text-base font-semibold" data-id="element-9" data-mp="2xuwuph2xk6ca">Onboarding</span>
              </motion.button>

              <motion.button layoutId="offboarding-toggle" onClick={() => setMode('offboarding')} className="flex items-center justify-center w-full sm:w-56 py-4 px-6 bg-white text-gray-700 border border-gray-200 rounded-xl shadow-sm hover:bg-gray-50 hover:shadow-md hover:-translate-y-0.5 transition-all duration-200 group" data-id="element-10" data-mp="2svtr812lm86f">
                <UserMinusIcon className="w-5 h-5 mr-3 text-gray-500 group-hover:scale-110 transition-transform" data-id="element-11" data-mp="13eoce5y1ez37" />
                <span className="text-base font-semibold" data-id="element-12" data-mp="1r4iqequ3etp1">Offboarding</span>
              </motion.button>
            </motion.div>
          </motion.div> : <motion.div key="wizard" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.4,
        delay: 0.1
      }} className="w-full" data-id="element-13" data-mp="1w19eo1g1wvlj">
            <OnboardingWizard mode={mode} setMode={setMode} offboardingContext={offboardingContext} flowOutcome={flowOutcome} data-id="element-14" data-mp="6qs21it7100f" />
          </motion.div>}
      </AnimatePresence>
    </LayoutGroup>;
}